import { Component, Input, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { coinsService } from "../../../services/coins.service";
import { alert } from "../../../services/alert.service";
import { authService } from "../../../services/auth.service";
import { utilityService } from "../../../services/utility.service";
import { IdentificationCommentsComponent } from "../../../popups/identification-comments/identification-comments.component";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { PageStateService } from "../../../services/helper/page-state.service";

@Component({
  selector: "app-coin-card",
  templateUrl: "./coin-card.component.html",
  styleUrls: ["./coin-card.component.scss"],
  standalone: false,
})
export class CoinCardComponent implements OnInit {
  @Input() page: string = "master";
  @Input() coin: any;
  @Input() type: string = "personal";
  @Input() allowReport: boolean = false;
  @Input() isSimilarCoin: boolean = false;
  @Input() isStats: boolean = false;
  @Input() isActionButton: boolean = true;

  comment: string;

  isBlockForm: boolean = false;

  totalAssessments: number = 0;
  totalIdentifications: number = 0;
  coinDetails: any[] = [];

  totalComments: number = 0;
  constructor(
    private coinService: coinsService,
    public auth: authService,
    private alertService: alert,
    public utility: utilityService,
    private router: Router,
    public dialog: MatDialog,
    private pageState: PageStateService
  ) {}

  ngOnInit(): void {
    this.totalAssessments = this.coin?.totalAssessments || 0;
    this.totalIdentifications = this.coin?.totalIdentifications || 0;
    this.totalComments = this.totalAssessments + this.totalIdentifications;
    this.setCoinDetails();
    console.log("page", this.page);
  }

  transformBaseUrl: string = "https://coincuriosity.us/cdn-cgi/image";
  getTransformedImageUrl(
    imageUrl: string,
    width: number = 150,
    quality: number = 75
  ): string | null {
    if (!imageUrl) {
      return null;
    }
    return `${this.transformBaseUrl}/width=${width},quality=${quality}/${imageUrl}`;
  }

  setCoinDetails(): void {
    this.coinDetails = [
      { label: "Year", value: this.coin?.year },
      { label: "Mint", value: this.coin?.mint },
      { label: "Type", value: this.coin?.type },
      { label: "Denomination", value: this.coin?.denomination },
      { label: "Variety", value: this.coin?.variety },
      { label: "Finish", value: this.coin?.proof },
    ];
  }

  isPersonal(): boolean {
    return (
      !!this.auth?.userAuthData &&
      this.auth.userAuthData.user.id === this.coin?.user_id
    );
  }

  submitForm(form: NgForm): void {
    if (!this.auth.userAuthData) {
      this.alertService.responseAlert("Please login", "error");
      return;
    }

    if (!form.valid) return;

    const reportData = {
      coin_id: this.coin?.id,
      user_id: this.coin?.user_id,
      report_by: this.auth.userAuthData?.user?.id,
      report_comment: this.comment,
    };

    this.coinService.saveCoinReport(reportData).subscribe({
      next: () => {
        this.alertService.responseAlert(
          "Coin reported successfully",
          "success"
        );
        this.coin.is_report = true;
        this.utility.reset();
      },
      error: (err) => {
        console.error("Error updating coin:", err);
        this.alertService.responseAlert("Failed to report the coin", "error");
      },
    });
  }

  identificationComment(coinId: string): void {
    const dialogRef = this.dialog.open(IdentificationCommentsComponent, {
      maxWidth: "100vw",
      panelClass: "comments-popup",
      data: coinId,
    });
  }

  isAssessments(): boolean {
    return !!this.coin?.assessments && this.coin?.assessments.length > 0;
  }

  navigate(): void {
    if (this.auth.userAuthData) {
      if (this.page == "master") {
        this.pageState.setBackPoint("master-collection", {
          scrollY: window.scrollY,
          coinId: this.coin?.id,
        });
        this.router.navigate(["/coins/coin-detail", this.coin.id], {
          queryParams: { collection: "master" },
        });
        return;
      }
      if (this.isSimilarCoin) {
        this.router.navigate(["/coins/coin-detail", this.coin.id], {
          queryParams: { collection: "detail" },
        });
        return;
      }
      if (this.isPersonal()) {
        if (this.page === "assess") {
          this.pageState.setBackPoint("assess-collection", {
            scrollY: window.scrollY,
            coinId: this.coin?.id,
          });
        }
        if (this.page === "identify") {
          this.pageState.setBackPoint("identify-collection", {
            scrollY: window.scrollY,
            coinId: this.coin?.id,
          });
        }
        this.router.navigate(["/coins/coin-detail", this.coin.id], {
          queryParams: { collection: "detail" },
        });
      } else {
        if (this.coin.status == "identify") {
          if (this.page === "identify") {
            this.pageState.setBackPoint("identify-collection", {
              scrollY: window.scrollY,
              coinId: this.coin?.id,
            });
          }
          this.router.navigate(["/coins/identify", this.coin.id]);
        }
        if (this.coin.status == "assess") {
          if (this.page === "assess") {
            this.pageState.setBackPoint("assess-collection", {
              scrollY: window.scrollY,
              coinId: this.coin?.id,
            });
          }
          this.router.navigate(["/coins/assess", this.coin.id]);
        }
      }
    } else {
      this.router.navigate(["/user/login"]);
    }
  }

  getCoinId(): string {
    return this.coin.id;
  }
}
